import { configureStore } from "@reduxjs/toolkit";
import confirmSnackbarReducer from "./confirmSnackbarSlice";

const store = configureStore({
  reducer: {
    confirmSnackbar: confirmSnackbarReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
